var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[(_vm.current_user)?_c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12,"offset":6}},[_c('safe',{attrs:{"user":_vm.current_user}})],1)],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }